
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Box, Button, FormControl, FormHelperText, FormLabel, Input, useToast } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'

import PageContent from '../components/PageContent'
import { requestResetPassword } from '../utils/api'
import { useRouter } from 'next/router'
import HeadingText from '../components/HeadingText'

type FormValues = {
  email: string
}
export default function ForgotPasswordPage() {
  const [isLoading, setIsLoading] = useState(false)
  const { register, errors, handleSubmit } = useForm<FormValues>()
  const toast = useToast()
  const router = useRouter()
  const { t } = useTranslation('forgotPassword')

  const save = async (formValues: FormValues) => {
    console.log(formValues)
    try {
      setIsLoading(true)
      const data = await requestResetPassword(formValues.email)

      if (data.ok) {
        toast({
          title: '알림',
          position: 'top',
          description: '패스워드 초기화 요청이 완료되었습니다. 입력하신 이메일의 받은편지함을 확인해주세요.',
        })
        router.push('/')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <PageContent>
      <HeadingText as="h1">{t('title')}</HeadingText>
      <Box maxW="400px" padding="16px" bgColor="whiteAlpha.100" mt="16px">
        <form onSubmit={handleSubmit(save)}>
          <FormControl>
            <FormLabel>email</FormLabel>
            <Input
              name="email"
              ref={register({
                required: {
                  value: true,
                  message: t('email-error-required'),
                },
                pattern: {
                  value:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: t('email-error-pattern'),
                },
              })}
              type="email"
              disabled={isLoading}
            />
            {errors.email && <FormHelperText>{errors.email.message}</FormHelperText>}
            <FormHelperText>{t('description')}</FormHelperText>
          </FormControl>
          <Button w="100%" type="submit" mt="16px" colorScheme="blue" disabled={isLoading}>
            {t('submit')}
          </Button>
        </form>
      </Box>
    </PageContent>
  )
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/forgot-password',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  